import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import { fromJS } from 'immutable'
import styled from 'styled-components'
import AdminNavbar from '../../components/AdminNavbar'
import CardContainer from '../../components/CardContainer'
import ThemeContainer from '../../components/ThemeContainer'
import { deleteCategory } from '../../sources/AdminSource'
import { searchCategories } from '../../sources/SearchSource'
import Input from '../../components/Input'
import { Metrics, Fonts } from '../../Themes'
import Trash from '../../svg-icons/Trash'
import DialogModal from '../../components/Modal/DialogModal'

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const EditArea = styled.div`
  padding-bottom: ${Metrics.margins.base};
  border-bottom: ${Metrics.borders.default};
`

const CategoryName = styled.div`${Fonts.style.Label};`

const Category = styled.div`
  height: 50px;
  border-bottom: ${Metrics.borders.default};
  padding: ${Metrics.margins.base} 0;
  cursor: pointer;
  position: relative;
  svg {
    position: absolute;
    right: 0;
    top: ${Metrics.margins.medium};
    float: right;
    cursor: pointer;
  }
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const Container = styled.div`
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

class AdminCategories extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      categories: [],
      categoryToDelete: null,
      modal: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.fetchCategories = this.fetchCategories.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { name, modal, categories, categoryToDelete } = this.state
    if (
      name !== nextState.name ||
      modal !== nextState.modal ||
      !fromJS(nextState.categories).equals(fromJS(categories)) ||
      categoryToDelete !== nextState.categoryToDelete
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchCategories()
  }

  handleChange (event) {
    this.setState({ name: event.target.value }, () =>
      searchCategories({
        where: {
          name: {
            startsWith: this.state.name
          }
        }
      })
        .then(response => this.setState({ categories: response.data }))
        .catch(error => console.log(error))
    )
  }

  selectCategoryToDelete (el) {
    this.setState({ categoryToDelete: el, modal: 'dialog' })
  }

  fetchCategories () {
    return searchCategories()
      .then(response => this.setState({ categories: response.data }))
      .catch(error => console.log(error))
  }

  handleDelete () {
    deleteCategory(this.state.categoryToDelete.id)
      .then(response => this.setState({ modal: false }, this.fetchCategories()))
      .catch(error => {
        console.log(error)
        this.setState({ modal: false })
      })
  }

  closeModal () {
    this.setState({ modal: false })
  }

  render () {
    const { t, admin, dropdownLinks, router } = this.props
    const { name, categories, modal } = this.state
    return (
      <Container>
        <AdminNavbar
          admin={admin}
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={[
            {
              label: t('Create Category'),
              secondary: true,
              onClick: () => router.push('/admin/categories/new')
            }
          ]}
        />
        <CustomThemeContainer>
          <DialogModal
            visible={modal === 'dialog'}
            header={t('Delete Category')}
            message={t('Do you really want to delete the category?')}
            buttons={{
              apply: { label: t('Delete'), onClick: this.handleDelete },
              cancel: { label: t('Cancel'), onClick: this.closeModal }
            }}
            closeAction={this.closeModal}
          />
          <CustomCardContainer title={t('Categories')}>
            <EditArea>
              <Input
                placeholder={t('Search category')}
                handleChange={this.handleChange}
                value={name}
              />
            </EditArea>
            {categories &&
              categories.length > 0 &&
              categories.map((category, index) => {
                return (
                  <Category
                    key={`category-${index}`}
                    onClick={() =>
                      router.push(`/admin/categories/${category.id}`)}>
                    <CategoryName>{category.name}</CategoryName>
                    <Trash
                      onClick={event => {
                        event.stopPropagation()
                        this.selectCategoryToDelete(category)
                      }}
                    />
                  </Category>
                )
              })}
          </CustomCardContainer>
        </CustomThemeContainer>
      </Container>
    )
  }
}

AdminCategories.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(AdminCategories)



// WEBPACK FOOTER //
// ./src/pages/AdminCategories/index.js